<template>
    <q-dialog v-model="modal"
              :maximized="$q.platform.is.mobile">
        <q-card class="modal-contactus">
            <div class="modal-header">
                <span class="modal-title">Написать нам</span>
                <div class="modal-close" @click="hideModal">
                    <span aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                            <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
            </div>
            <q-card-section class="modal-content">
                <q-input square outlined v-model="name" label="Ваше Имя*"
                         :error-message="getError('name')"
                         :error="hasError('name')" />
                <q-input square outlined v-model="email" label="Ваш Email*"
                         :error-message="getError('email')"
                         :error="hasError('email')"/>
                <q-input square outlined v-model="city" label="Ваш Город"
                         :error-message="getError('city')"
                         :error="hasError('city')"/>
                <q-input square outlined v-model="message" type="textarea" label="Ваше сообщение*"
                         :error-message="getError('message')"
                         :error="hasError('message')"/>
                <p class="text-weight-thin q-pb-md">* - обязательные поля</p>
                <span class="btn mt-auto" @click.prevent="submitContactUs">Написать</span>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

    export default {
        name: "ContactUs",
        computed: {
            ...mapState('contactUs', ['form']),
            ...mapGetters('contactUs', [
                'hasError',
                'getError'
            ]),
            modal: {
                get () {
                    return this.$store.state.contactUs.modal;
                },
                set () {
                    this.hideModal();
                }
            },
            name: {
                get () {
                    return this.$store.state.contactUs.form.name;
                },
                set (value) {
                    this.$store.commit('contactUs/setFormValue', {
                        key: 'name',
                        value: value
                    });
                }
            },
            email: {
                get () {
                    return this.$store.state.contactUs.form.email;
                },
                set (value) {
                    this.$store.commit('contactUs/setFormValue', {
                        key: 'email',
                        value: value
                    });
                }
            },
            city: {
                get () {
                    return this.$store.state.contactUs.form.city;
                },
                set (value) {
                    this.$store.commit('contactUs/setFormValue', {
                        key: 'city',
                        value: value
                    });
                }
            },
            message: {
                get () {
                    return this.$store.state.contactUs.form.message;
                },
                set (value) {
                    this.$store.commit('contactUs/setFormValue', {
                        key: 'message',
                        value: value
                    });
                }
            },
        },
        methods: {
            ...mapMutations('contactUs', [
                'hideModal',
            ]),
            ...mapActions('contactUs', [
                'submit'
            ]),
            submitContactUs () {
                let _this = this;
                _this.submit();
            },
        }
    }
</script>
